<template>
  <div class="right-panel-wrapper">
    <div class="right-panel">
    <div class="card section-environment">
      <div class="section-header">
        <div class="section-title">社区环境监测</div>
        <button class="btn btn-sm" @click="showEnvironmentDetail">详情</button>
      </div>
      <MetricCards
        :metrics="envMetrics"
        :format-value="formatMetricValue"
        :get-color="getMetricColor"
        :should-hide-unit="isWindDirection"
      />
          </div>

    <div class="card section-water-quality">
      <div class="section-header">
        <div class="section-title">社区水质监测</div>
        <button class="btn btn-sm" @click="showWaterQualityDetail">详情</button>
        </div>
      <MetricCards
        :metrics="waterQualityMetrics"
        :format-value="formatWaterQualityValue"
        :get-color="getWaterQualityColor"
      />
      </div>

    <div class="card section-lighting-pole">
      <div class="section-header">
        <div class="section-title">社区灯杆监测</div>
        <button class="btn btn-sm" @click="showLightingPoleDetail">详情</button>
      </div>
      <MetricCards
        :metrics="lightingPoleMetrics"
        :format-value="formatLightingPoleValue"
        :get-color="getLightingPoleColor"
      />
    </div>

<!--    <div class="card section-alarm">-->
<!--      <div class="section-header">-->
<!--        <div class="section-title">社区告警态势</div>-->
<!--        <button class="btn btn-sm" @click="showDetails">详情</button>-->
<!--      </div>-->
<!--      <div class="alarm-count">-->
<!--        <span class="count-label">告警事件数量</span>-->
<!--        <span class="count-value">{{ alarmCount }}</span>-->
<!--        <span class="count-unit">件</span>-->
<!--      </div>-->
<!--      <div class="alarm-chart">-->
<!--        <div ref="alarmChartRef" class="chart-container"></div>-->
<!--      </div>-->
<!--      <div class="alarm-list">-->
<!--        <div v-for="alarm in alarmList" :key="alarm.type" class="alarm-item" :style="alarmItemStyle(alarm.type)">-->
<!--          <span class="alarm-type">{{ alarm.type }}</span>-->
<!--          <span class="alarm-count-text" :style="alarmCountStyle(alarm.type)">{{ alarm.count }} 条</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts'
import MetricCards from './MetricCards.vue'
import { communityStore } from '../stores/community'
import { getCommunityConfig, COMMUNITIES } from '../utils/communityConfig'
import { REFRESH_CONFIG } from '../utils/refreshConfig'
import request from '@/utils/request'
import { getCurrentCommunity } from '@/utils/vc'

export default {
  name: 'RightPanel',
  components: {
    MetricCards
  },
  data() {
    return {
      communityStore,
      alarmChart: null,
      entryStats: [],
      alarmCount: 0,
      alarmList: [],
      envMetrics: [],
      pm25TrendData: null,
      entryStatsTimer: null, // 出入态势数据刷新定时器
      environmentTimer: null, // 环境监测数据刷新定时器
      waterQualityTimer: null, // 水质监测数据刷新定时器
      lightingPoleTimer: null, // 灯杆监测数据刷新定时器
      // 水质监测数据
      waterQualityMetrics: [],
      waterQualityTrendData: null,
      // 灯杆监测数据
      lightingPoleMetrics: [],
      lightingPoleTrendData: null
    }
  },
  watch: {
    'communityStore.currentCommunity'() {
      this.loadEntryStatsFromAPI() // 先从后端获取数据覆盖配置
      this.loadCommunityData() // 然后加载数据
      this.loadEnvironmentData() // 加载环境监测数据
    }
  },
  mounted() {
    // 只有当 ref 存在时才初始化图表
    if (this.$refs.alarmChartRef) {
      this.alarmChart = echarts.init(this.$refs.alarmChartRef)
    }
    this.loadEntryStatsFromAPI() // 先从后端获取数据覆盖配置
    this.loadCommunityData() // 然后加载数据
    this.loadEnvironmentData() // 加载环境监测数据
    this.loadWaterQualityData() // 加载水质监测数据
    this.loadLightingPoleData() // 加载灯杆监测数据

    // 定时更新出入态势数据
    this.entryStatsTimer = setInterval(() => {
      this.loadEntryStatsFromAPI()
    }, REFRESH_CONFIG.ENTRY_STATS)

    // 定时更新环境监测数据
    this.environmentTimer = setInterval(() => {
      this.loadEnvironmentData()
    }, REFRESH_CONFIG.ENVIRONMENT_MONITOR)

    // 定时更新水质监测数据
    this.waterQualityTimer = setInterval(() => {
      this.loadWaterQualityData()
    }, REFRESH_CONFIG.ENVIRONMENT_MONITOR)

    // 定时更新灯杆监测数据
    this.lightingPoleTimer = setInterval(() => {
      this.loadLightingPoleData()
    }, REFRESH_CONFIG.ENVIRONMENT_MONITOR)

    this.handleResize = () => {
      if (this.alarmChart) this.alarmChart.resize()
    }
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    // 从后端API获取数据并更新配置
    loadEntryStatsFromAPI() {
      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
        return
      }

      if (!communityId) {
        console.warn('communityId 为空，无法获取社区出入态势信息')
        return
      }

      // 调用接口获取社区出入态势信息（如果有对应的API）
      // 这里假设有一个 getEntryStats API，如果没有可以注释掉或删除
      request({
        url: '/app/bigScreen/getEntryStats',
        method: 'get',
        params: {
          communityId: communityId
        },
        showLoading: false
      }).then(response => {
        const res = response.data
        if (res && res.code === 0 && res.data) {
          const data = res.data
          const currentCommunityName = this.communityStore.currentCommunity
          const cfg = COMMUNITIES[currentCommunityName]

          if (!cfg || !cfg.data || !cfg.data.entryStats) {
            console.warn('未找到社区配置:', currentCommunityName)
            return
          }

          // 更新出入态势统计数据（根据配置中的 field 字段动态查找并更新 value）
          cfg.data.entryStats.forEach(stat => {
            if (stat.field && data[stat.field] !== undefined) {
              stat.current = data[stat.field] || 0
            }
            if (stat.fieldTotal && data[stat.fieldTotal] !== undefined) {
              stat.total = data[stat.fieldTotal] || 0
            }
          })

          // 数据更新后，重新加载
          this.loadCommunityData()
        }
      }).catch(error => {
        // 如果API不存在或失败，静默失败，使用配置中的默认值
        console.warn('获取社区出入态势信息失败，使用默认配置数据:', error)
        this.loadCommunityData()
      })
    },
    loadCommunityData() {
      const cfg = getCommunityConfig(this.communityStore.currentCommunity)
      this.entryStats = (cfg.data && cfg.data.entryStats) || []
      this.alarmCount = (cfg.data && cfg.data.alarm && cfg.data.alarm.count) !== undefined ? cfg.data.alarm.count : 0
      this.alarmList = this.normalizeAlarmList((cfg.data && cfg.data.alarm && cfg.data.alarm.list) || [])
      this.updateAlarmChart()
      // 从配置中加载环境监测数据
      if (cfg.data && cfg.data.environment) {
        this.envMetrics = cfg.data.environment.metrics || []
        this.pm25TrendData = cfg.data.environment.pm25Trend || null
        // 直接使用配置数据，不强制更新最后一个值

      }
    },
    normalizeAlarmList(list) {
      const expected = ['高空抛物告警:', '垃圾满溢告警:', '陌生人告警:', '老年人告警:']
      const map = new Map((list || []).map((it) => [it.type, it]))
      return expected.map((type) => map.get(type) || { type, count: 0 })
    },
    updateAlarmChart() {
      if (!this.alarmChart) return
      this.alarmChart.setOption({
        tooltip: { trigger: 'item' },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            label: { show: false },
            labelLine: { show: false },
            data: this.alarmList.map((it, idx) => ({
              value: it.count,
              name: String(it.type).replace(':', ''),
              itemStyle: { color: this.getAlarmColor(it.type, idx) }
            }))
          }
        ]
      })
    },
    getAlarmColor(type, idx = 0) {
      const palette = ['#00d4ff', '#ff5a5a', '#ff7a00', '#9c27b0', '#ffd54a', '#4ecdc4', '#a8e6cf', '#0ff']
      const t = String(type || '')
      if (t.includes('高空抛物')) return '#00d4ff'
      if (t.includes('垃圾')) return '#ff5a5a'
      if (t.includes('陌生人')) return '#9c27b0'
      if (t.includes('老年人')) return '#ffd54a'
      return palette[idx % palette.length]
    },
    alarmItemStyle(type) {
      const c = this.getAlarmColor(type)
      return {
        borderLeftColor: c,
        background: `${c}0D` // 使用对应颜色的半透明背景
      }
    },
    alarmCountStyle(type) {
      const c = this.getAlarmColor(type)
      return {
        background: `${c}22`,
        borderColor: `${c}55`,
        color: c
      }
    },
    showDetails() {
      // TODO: 弹窗
    },
    // 显示社区环境监测详情 - 通过事件总线发送到 CenterMap
    showEnvironmentDetail() {
      this.$root.$emit('show-detail-dialog', {
        type: 'environment',
        title: '社区环境监测',
        chartGroups: [
          {
            title: '大气压力',
            fields: ['atmPress']
          },
          {
            title: '光照度',
            fields: ['illumination']
          },
          {
            title: '气象指标',
            fields: ['windSpeed', 'windDir', 'atmTemp', 'atmHum']
          },
          {
            title: '空气质量与环境噪声',
            fields: ['pm25', 'pm10', 'noise']
          }
        ],
        basicStats: this.envMetrics ? this.envMetrics.map(metric => ({
          ...metric,
          colorType: this.getMetricColorType(metric.label, metric.value)
        })) : [],
        trendData: this.pm25TrendData,
        formatValue: this.formatMetricValue,
        getColor: this.getMetricColor,
        shouldHideUnit: this.isWindDirection
      })
    },
    // 显示社区水质监测详情 - 通过事件总线发送到 CenterMap
    showWaterQualityDetail() {
      this.$root.$emit('show-detail-dialog', {
        type: 'waterQuality',
        title: '社区水质监测',
        chartGroups: [
          {
            title: 'PH值与浊度',
            fields: ['pH', 'turbidity']
          },
          {
            title: '余氯与电导率',
            fields: ['chlorine', 'conductivity']
          },
          {
            title: '氨氮与氟离子',
            fields: ['ammoniaNitrogen', 'fluoride']
          },
          {
            title: '色度与温度',
            fields: ['color', 'temperature']
          }
        ],
        basicStats: this.waterQualityMetrics ? this.waterQualityMetrics.map(metric => ({
          ...metric,
          colorType: this.getWaterQualityColorType(metric.label, metric.value)
        })) : [],
        trendData: this.waterQualityTrendData,
        formatValue: this.formatWaterQualityValue,
        getColor: this.getWaterQualityColor
      })
    },
    // 显示社区灯杆监测详情 - 通过事件总线发送到 CenterMap
    showLightingPoleDetail() {
      this.$root.$emit('show-detail-dialog', {
        type: 'lightingPole',
        title: '社区灯杆监测',
        chartGroups: [
          {
            title: '调光亮度',
            fields: ['dimmingBrightness']
          }
        ],
        basicStats: this.lightingPoleMetrics ? this.lightingPoleMetrics.map(metric => ({
          ...metric,
          colorType: this.getLightingPoleColorType(metric.label, metric.value)
        })) : [],
        trendData: this.lightingPoleTrendData,
        formatValue: this.formatLightingPoleValue,
        getColor: this.getLightingPoleColor
      })
    },
    // 判断是否是风向指标
    isWindDirection(label) {
      return label && label.includes('风向')
    },
    // 将风向度数转换为枚举值（0-7）
    getWindDirectionEnum(degrees) {
      const numValue = parseFloat(degrees) || 0

      // 如果值在0-7范围内，认为是枚举值，直接返回
      if (numValue >= 0 && numValue <= 7 && numValue === Math.floor(numValue)) {
        return Math.floor(numValue)
      }

      // 否则认为是度数（0-360），需要转换为枚举值
      // 将度数归一化到0-360范围
      let normalized = numValue % 360
      if (normalized < 0) normalized += 360

      // 根据枚举规则转换：0-7对应8个方向
      // 0: 北风 (0-22.5 或 337.5-360)
      // 1: 东北风 (22.5-67.5)
      // 2: 东风 (67.5-112.5)
      // 3: 东南风 (112.5-157.5)
      // 4: 南风 (157.5-202.5)
      // 5: 西南风 (202.5-247.5)
      // 6: 西风 (247.5-292.5)
      // 7: 西北风 (292.5-337.5)
      if (normalized >= 337.5 || normalized < 22.5) return 0 // 北风
      if (normalized >= 22.5 && normalized < 67.5) return 1 // 东北风
      if (normalized >= 67.5 && normalized < 112.5) return 2 // 东风
      if (normalized >= 112.5 && normalized < 157.5) return 3 // 东南风
      if (normalized >= 157.5 && normalized < 202.5) return 4 // 南风
      if (normalized >= 202.5 && normalized < 247.5) return 5 // 西南风
      if (normalized >= 247.5 && normalized < 292.5) return 6 // 西风
      if (normalized >= 292.5 && normalized < 337.5) return 7 // 西北风
      return 0 // 默认返回北风
    },
    // 获取风向枚举对应的中文名称
    getWindDirectionName(enumValue) {
      const windDirectionMap = {
        0: '北风',
        1: '东北风',
        2: '东风',
        3: '东南风',
        4: '南风',
        5: '西南风',
        6: '西风',
        7: '西北风'
      }
      return windDirectionMap[enumValue] || '未知'
    },
    // 格式化指标显示值
    formatMetricValue(label, value) {
      if (this.isWindDirection(label)) {
        // 风向：将度数转换为枚举值，然后显示中文名称
        const enumValue = this.getWindDirectionEnum(value)
        return this.getWindDirectionName(enumValue)
      }
      // 其他指标直接显示原值
      return value
    },
    getMetricColorType(label, value) {
      // 根据指标名称和实际值返回颜色类型：green(绿色-正常)、blue(蓝色-良好)、yellow(黄色-警告)、red(红色-危险)
      const numValue = parseFloat(value) || 0

      if (label.includes('风速')) {
        // 风速：根据风力等级判断
        // 0-5.4 m/s (0-3级微风) - 绿色，5.5-10.7 m/s (4-5级和风) - 蓝色，10.8-13.8 m/s (6级强风) - 黄色，>13.8 m/s (7级以上) - 红色
        if (numValue <= 5.4) {
          return 'green'
        } else if (numValue <= 10.7) {
          return 'blue'
        } else if (numValue <= 13.8) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('风向')) {
        // 风向：中性指标，显示蓝色
        return 'blue'
      } else if (label.includes('大气温度')) {
        // 大气温度：18-26℃绿色(舒适)，10-18或26-30℃蓝色(较舒适)，0-10或30-35℃黄色(不舒适)，其他红色(极端)
        if (numValue >= 18 && numValue <= 26) {
          return 'green'
        } else if ((numValue >= 10 && numValue < 18) || (numValue > 26 && numValue <= 30)) {
          return 'blue'
        } else if ((numValue >= 0 && numValue < 10) || (numValue > 30 && numValue <= 35)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('大气湿度')) {
        // 大气湿度：40-60%RH绿色(舒适)，30-40或60-70%RH蓝色(较舒适)，20-30或70-80%RH黄色(不舒适)，其他红色(极端)
        if (numValue >= 40 && numValue <= 60) {
          return 'green'
        } else if ((numValue >= 30 && numValue < 40) || (numValue > 60 && numValue <= 70)) {
          return 'blue'
        } else if ((numValue >= 20 && numValue < 30) || (numValue > 70 && numValue <= 80)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('大气压力')) {
        // 大气压力：标准大气压1013hPa，±10hPa绿色(正常)，±20hPa蓝色(较正常)，±30hPa黄色(异常)，其他红色(极端)
        const standardPressure = 1013
        const diff = Math.abs(numValue - standardPressure)
        if (diff <= 10) {
          return 'green'
        } else if (diff <= 20) {
          return 'blue'
        } else if (diff <= 30) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('PM2.5')) {
        // PM2.5：根据空气质量标准
        // 0-35μg/m³绿色(优)，35-75μg/m³黄色(良)，75-115μg/m³红色(轻度污染)，>115μg/m³红色(中重度污染)
        if (numValue <= 35) {
          return 'green'
        } else if (numValue <= 75) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('PM10')) {
        // PM10：根据空气质量标准
        // 0-50μg/m³绿色(优)，50-150μg/m³黄色(良)，150-250μg/m³红色(轻度污染)，>250μg/m³红色(中重度污染)
        if (numValue <= 50) {
          return 'green'
        } else if (numValue <= 150) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('光照度')) {
        // 光照度：根据实际光照需求
        // 1000-100000Lux绿色(正常)，500-1000或100000-150000Lux蓝色(较正常)，200-500或150000-200000Lux黄色(异常)，其他红色(极端)
        if (numValue >= 1000 && numValue <= 100000) {
          return 'green'
        } else if ((numValue >= 500 && numValue < 1000) || (numValue > 100000 && numValue <= 150000)) {
          return 'blue'
        } else if ((numValue >= 200 && numValue < 500) || (numValue > 150000 && numValue <= 200000)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('环境噪声') || label.includes('噪声')) {
        // 环境噪声：根据噪声标准
        // 30-50dB绿色(安静)，50-70dB蓝色(较安静)，70-90dB黄色(较吵)，>90dB红色(很吵)
        if (numValue >= 30 && numValue <= 50) {
          return 'green'
        } else if (numValue > 50 && numValue <= 70) {
          return 'blue'
        } else if (numValue > 70 && numValue <= 90) {
          return 'yellow'
        } else {
          return 'red'
        }
      }
      // 默认蓝色
      return 'blue'
    },
    // 获取指标值的颜色（返回CSS颜色值）
    getMetricColor(label, value) {
      const colorType = this.getMetricColorType(label, value)
      const colorMap = {
        'green': '#4caf50',   // 绿色
        'blue': '#00d4ff',    // 蓝色
        'yellow': '#ffc107',  // 黄色
        'red': '#ff5a5a'      // 红色
      }
      return colorMap[colorType] || '#00d4ff' // 默认蓝色
    },
    // 加载环境监测数据
    loadEnvironmentData() {
      // 从配置中获取默认数据
      const cfg = getCommunityConfig(this.communityStore.currentCommunity)
      if (cfg.data && cfg.data.environment) {
        this.envMetrics = cfg.data.environment.metrics || []
        this.pm25TrendData = cfg.data.environment.pm25Trend || null
        // 直接使用配置数据，不强制更新最后一个值
      } else {
        // 如果配置中没有，使用空数组
        this.envMetrics = []
        this.pm25TrendData = null
      }

      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
        return
      }

      if (!communityId) {
        return
      }

      // 调用接口获取环境监测数据
      request({
        url: '/app/bigScreen/getEnvironmentMonitor',
        method: 'get',
        params: {
          communityId: communityId,
          deviceCode: 'D1647X4DWH2N'
        },
        showLoading: false
      }).then(response => {
        const res = response.data
        if (res && res.code === 0 && res.data) {
          const data = res.data
          const currentCommunityName = this.communityStore.currentCommunity
          const cfg = COMMUNITIES[currentCommunityName]

          if (!cfg || !cfg.data || !cfg.data.environment || !cfg.data.environment.metrics) {
            console.warn('未找到环境监测配置:', currentCommunityName)
            return
          }

          // 从后端返回的 data.environment.metrics 数组中根据 field 匹配并更新 value
          if (data.environment && data.environment.metrics) {
            const backendMetrics = data.environment.metrics
            cfg.data.environment.metrics.forEach(configMetric => {
              if (configMetric.field) {
                const backendMetric = backendMetrics.find(bm => bm.field === configMetric.field)
                if (backendMetric && backendMetric.value !== undefined) {
                  configMetric.value = String(backendMetric.value || '0')
                }
              }
            })
          }

          // 更新PM2.5趋势数据
          if (data.environment && data.environment.pm25Trend) {
            const backendTrend = data.environment.pm25Trend
            // 从配置中获取完整的 series 结构（包含 name、unit、min、max），然后更新 data
            if (backendTrend.series && cfg.data.environment.pm25Trend && cfg.data.environment.pm25Trend.series) {
              // 确保所有配置中的 series 都被更新，即使后端没有返回对应的数据
              // 先更新后端返回的 series
              backendTrend.series.forEach(backendSeries => {
                const configSeries = cfg.data.environment.pm25Trend.series.find(cs => cs.field === backendSeries.field)
                if (configSeries) {
                  // 更新 data 数组，保留其他字段（name、unit、min、max）
                  configSeries.data = backendSeries.data || []
                } else {
                  // 如果配置中没有对应的 series，创建一个新的（从 metrics 中获取 name 和 unit）
                  const metric = cfg.data.environment.metrics.find(m => m.field === backendSeries.field)
                  if (metric) {
                    cfg.data.environment.pm25Trend.series.push({
                      name: metric.label,
                      unit: metric.unit,
                      field: backendSeries.field,
                      data: backendSeries.data || [],
                      min: 0, // 默认值，可以从配置中获取
                      max: 100 // 默认值，可以从配置中获取
                    })
                  }
                }
              })
              // 确保配置中的所有 series 都有数据（如果后端没有返回，保持默认的空数组或0）
              cfg.data.environment.pm25Trend.series.forEach(configSeries => {
                const backendSeries = backendTrend.series.find(bs => bs.field === configSeries.field)
                if (!backendSeries && configSeries.data.length === 0) {
                  // 如果后端没有返回该field的数据，且配置中也没有数据，初始化为24个0
                  configSeries.data = new Array(24).fill(0)
                }
              })
            } else {
              // 如果配置中没有 series，从配置的 metrics 构建 series
              if (backendTrend.series && cfg.data.environment.metrics) {
                const newSeries = backendTrend.series.map(backendSeries => {
                  const metric = cfg.data.environment.metrics.find(m => m.field === backendSeries.field)
                  return {
                    name: metric ? metric.label : backendSeries.field,
                    unit: metric ? metric.unit : '',
                    field: backendSeries.field,
                    data: backendSeries.data || [],
                    min: 0,
                    max: 100
                  }
                })
                // 确保所有9个指标都有对应的series（即使后端没有返回）
                const allFields = ['windSpeed', 'windDir', 'atmTemp', 'atmHum', 'atmPress', 'pm25', 'pm10', 'illumination', 'noise']
                allFields.forEach(field => {
                  if (!newSeries.find(s => s.field === field)) {
                    const metric = cfg.data.environment.metrics.find(m => m.field === field)
                    if (metric) {
                      newSeries.push({
                        name: metric.label,
                        unit: metric.unit,
                        field: field,
                        data: new Array(24).fill(0),
                        min: 0,
                        max: 100
                      })
                    }
                  }
                })
                cfg.data.environment.pm25Trend = {
                  hours: backendTrend.hours || cfg.data.environment.pm25Trend.hours,
                  series: newSeries
                }
              } else {
                cfg.data.environment.pm25Trend = {
                  hours: backendTrend.hours || cfg.data.environment.pm25Trend.hours,
                  series: backendTrend.series || []
                }
              }
            }
          }

          // 重新从配置中读取更新后的数据（直接使用接口返回的数据，不强制更新最后一个值）
          this.envMetrics = cfg.data.environment.metrics
          this.pm25TrendData = cfg.data.environment.pm25Trend
        }
      }).catch(error => {
        console.warn('获取环境监测数据失败，使用默认配置数据:', error)
      })
    },
    // 加载水质监测数据
    loadWaterQualityData() {
      // 从配置中获取默认数据
      const cfg = getCommunityConfig(this.communityStore.currentCommunity)
      if (cfg.data && cfg.data.waterQuality) {
        this.waterQualityMetrics = cfg.data.waterQuality.metrics || []
        this.waterQualityTrendData = cfg.data.waterQuality.trend || null
      } else {
        // 如果配置中没有，使用空数组
        this.waterQualityMetrics = []
        this.waterQualityTrendData = null
      }

      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
        return
      }

      if (!communityId) {
        return
      }

      // 调用接口获取水质监测数据
      request({
        url: '/app/bigScreen/getWaterQuality',
        method: 'get',
        params: {
          communityId: communityId,
          deviceCode: '535337333615BC2B45FF'
        },
        showLoading: false
      }).then(response => {
        const res = response.data
        if (res && res.code === 0 && res.data) {
          const data = res.data
          const currentCommunityName = this.communityStore.currentCommunity
          const cfg = COMMUNITIES[currentCommunityName]

          if (!cfg || !cfg.data || !cfg.data.waterQuality || !cfg.data.waterQuality.metrics) {
            console.warn('未找到水质监测配置:', currentCommunityName)
            return
          }

          // 从后端返回的数据中根据 field 匹配并更新 value
          if (data.waterQuality && data.waterQuality.metrics) {
            const backendMetrics = data.waterQuality.metrics
            cfg.data.waterQuality.metrics.forEach(configMetric => {
              if (configMetric.field) {
                const backendMetric = backendMetrics.find(bm => bm.field === configMetric.field)
                if (backendMetric && backendMetric.value !== undefined) {
                  configMetric.value = String(backendMetric.value || '0')
                }
              }
            })
          }

          // 更新趋势数据
          if (data.waterQuality && data.waterQuality.trend) {
            const backendTrend = data.waterQuality.trend
            if (backendTrend.series && cfg.data.waterQuality.trend && cfg.data.waterQuality.trend.series) {
              backendTrend.series.forEach(backendSeries => {
                const configSeries = cfg.data.waterQuality.trend.series.find(cs => cs.field === backendSeries.field)
                if (configSeries) {
                  configSeries.data = backendSeries.data || []
                } else {
                  // 如果配置中没有对应的 series，创建一个新的（从 metrics 中获取 name 和 unit）
                  const metric = cfg.data.waterQuality.metrics.find(m => m.field === backendSeries.field)
                  if (metric) {
                    cfg.data.waterQuality.trend.series.push({
                      name: metric.label,
                      unit: metric.unit,
                      field: backendSeries.field,
                      data: backendSeries.data || [],
                      min: metric.min || 0,
                      max: metric.max || 100
                    })
                  }
                }
              })
              // 确保配置中的所有 series 都有数据（如果后端没有返回，保持默认的空数组或0）
              cfg.data.waterQuality.trend.series.forEach(configSeries => {
                const backendSeries = backendTrend.series.find(bs => bs.field === configSeries.field)
                if (!backendSeries && configSeries.data.length === 0) {
                  // 如果后端没有返回该field的数据，且配置中也没有数据，初始化为24个0
                  configSeries.data = new Array(24).fill(0)
                }
              })
            } else {
              // 如果配置中没有 series，从配置的 metrics 构建 series
              if (backendTrend.series && cfg.data.waterQuality.metrics) {
                const newSeries = backendTrend.series.map(backendSeries => {
                  const metric = cfg.data.waterQuality.metrics.find(m => m.field === backendSeries.field)
                  return {
                    name: metric ? metric.label : backendSeries.field,
                    unit: metric ? metric.unit : '',
                    field: backendSeries.field,
                    data: backendSeries.data || [],
                    min: metric ? (metric.min || 0) : 0,
                    max: metric ? (metric.max || 100) : 100
                  }
                })
                // 确保所有指标都有对应的series（即使后端没有返回）
                const allFields = ['pH', 'turbidity', 'chlorine', 'conductivity', 'ammoniaNitrogen', 'fluoride', 'color', 'temperature']
                allFields.forEach(field => {
                  if (!newSeries.find(s => s.field === field)) {
                    const metric = cfg.data.waterQuality.metrics.find(m => m.field === field)
                    if (metric) {
                      newSeries.push({
                        name: metric.label,
                        unit: metric.unit,
                        field: field,
                        data: new Array(24).fill(0),
                        min: metric.min || 0,
                        max: metric.max || 100
                      })
                    }
                  }
                })
                cfg.data.waterQuality.trend = {
                  hours: backendTrend.hours || cfg.data.waterQuality.trend.hours,
                  series: newSeries
                }
              } else {
                cfg.data.waterQuality.trend = {
                  hours: backendTrend.hours || cfg.data.waterQuality.trend.hours,
                  series: backendTrend.series || []
                }
              }
            }
          }

          // 重新从配置中读取更新后的数据（直接使用接口返回的数据，不强制更新最后一个值）
          this.waterQualityMetrics = cfg.data.waterQuality.metrics
          this.waterQualityTrendData = cfg.data.waterQuality.trend
        }
      }).catch(error => {
        console.warn('获取水质监测数据失败，使用默认配置数据:', error)
      })
    },
    // 格式化水质指标显示值
    formatWaterQualityValue(label, value) {
      // 水质指标直接显示数值，保留适当小数位
      const numValue = parseFloat(value)
      if (isNaN(numValue)) {
        return value
      }
      // 根据指标类型决定小数位数
      if (label.includes('PH值') || label.includes('pH')) {
        return numValue.toFixed(1)
      } else if (label.includes('浊度') || label.includes('余氯') || label.includes('氨氮') || label.includes('氟离子')) {
        return numValue.toFixed(2)
      } else if (label.includes('电导率')) {
        return Math.round(numValue).toString()
      } else if (label.includes('色度')) {
        return Math.round(numValue).toString()
      } else if (label.includes('温度')) {
        return numValue.toFixed(1)
      }
      return numValue.toString()
    },
    // 获取水质指标颜色类型
    getWaterQualityColorType(label, value) {
      const numValue = parseFloat(value) || 0

      if (label.includes('PH值') || label.includes('pH')) {
        // PH值：6.5-8.5绿色(正常)，6.0-6.5或8.5-9.0蓝色(较正常)，5.5-6.0或9.0-9.5黄色(异常)，其他红色(极端)
        if (numValue >= 6.5 && numValue <= 8.5) {
          return 'green'
        } else if ((numValue >= 6.0 && numValue < 6.5) || (numValue > 8.5 && numValue <= 9.0)) {
          return 'blue'
        } else if ((numValue >= 5.5 && numValue < 6.0) || (numValue > 9.0 && numValue <= 9.5)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('浊度')) {
        // 浊度：0-1NTU绿色(优秀)，1-5NTU蓝色(良好)，5-10NTU黄色(一般)，>10NTU红色(差)
        if (numValue <= 1) {
          return 'green'
        } else if (numValue <= 5) {
          return 'blue'
        } else if (numValue <= 10) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('余氯')) {
        // 余氯：0.3-0.8mg/L绿色(正常)，0.2-0.3或0.8-1.0mg/L蓝色(较正常)，0.1-0.2或1.0-1.5mg/L黄色(异常)，其他红色(极端)
        if (numValue >= 0.3 && numValue <= 0.8) {
          return 'green'
        } else if ((numValue >= 0.2 && numValue < 0.3) || (numValue > 0.8 && numValue <= 1.0)) {
          return 'blue'
        } else if ((numValue >= 0.1 && numValue < 0.2) || (numValue > 1.0 && numValue <= 1.5)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('电导率')) {
        // 电导率：200-800µS/cm绿色(正常)，100-200或800-1500µS/cm蓝色(较正常)，50-100或1500-2000µS/cm黄色(异常)，其他红色(极端)
        if (numValue >= 200 && numValue <= 800) {
          return 'green'
        } else if ((numValue >= 100 && numValue < 200) || (numValue > 800 && numValue <= 1500)) {
          return 'blue'
        } else if ((numValue >= 50 && numValue < 100) || (numValue > 1500 && numValue <= 2000)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('氨氮')) {
        // 氨氮：0-0.5mg/L绿色(优秀)，0.5-1.0mg/L蓝色(良好)，1.0-2.0mg/L黄色(一般)，>2.0mg/L红色(差)
        if (numValue <= 0.5) {
          return 'green'
        } else if (numValue <= 1.0) {
          return 'blue'
        } else if (numValue <= 2.0) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('氟离子')) {
        // 氟离子：0.5-1.0mg/L绿色(正常)，0.3-0.5或1.0-1.5mg/L蓝色(较正常)，0.1-0.3或1.5-2.0mg/L黄色(异常)，其他红色(极端)
        if (numValue >= 0.5 && numValue <= 1.0) {
          return 'green'
        } else if ((numValue >= 0.3 && numValue < 0.5) || (numValue > 1.0 && numValue <= 1.5)) {
          return 'blue'
        } else if ((numValue >= 0.1 && numValue < 0.3) || (numValue > 1.5 && numValue <= 2.0)) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('色度')) {
        // 色度：0-15度绿色(优秀)，15-30度蓝色(良好)，30-50度黄色(一般)，>50度红色(差)
        if (numValue <= 15) {
          return 'green'
        } else if (numValue <= 30) {
          return 'blue'
        } else if (numValue <= 50) {
          return 'yellow'
        } else {
          return 'red'
        }
      } else if (label.includes('温度')) {
        // 温度：10-25°C绿色(正常)，5-10或25-30°C蓝色(较正常)，0-5或30-35°C黄色(异常)，其他红色(极端)
        if (numValue >= 10 && numValue <= 25) {
          return 'green'
        } else if ((numValue >= 5 && numValue < 10) || (numValue > 25 && numValue <= 30)) {
          return 'blue'
        } else if ((numValue >= 0 && numValue < 5) || (numValue > 30 && numValue <= 35)) {
          return 'yellow'
        } else {
          return 'red'
        }
      }
      // 默认蓝色
      return 'blue'
    },
    // 获取水质指标值的颜色（返回CSS颜色值）
    getWaterQualityColor(label, value) {
      const colorType = this.getWaterQualityColorType(label, value)
      const colorMap = {
        'green': '#4caf50',
        'blue': '#00d4ff',
        'yellow': '#ffc107',
        'red': '#ff5a5a'
      }
      return colorMap[colorType] || '#00d4ff'
    },
    // 加载灯杆监测数据
    loadLightingPoleData() {
      // 从配置中获取默认数据
      const cfg = getCommunityConfig(this.communityStore.currentCommunity)
      if (cfg.data && cfg.data.lightingPole) {
        this.lightingPoleMetrics = cfg.data.lightingPole.metrics || []
        this.lightingPoleTrendData = cfg.data.lightingPole.trend || null
      } else {
        // 如果配置中没有，使用空数组
        this.lightingPoleMetrics = []
        this.lightingPoleTrendData = null
      }

      // 获取当前社区的 communityId
      let communityId = null
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.communityId) {
          communityId = currentCommunity.communityId
        }
      } catch (e) {
        console.warn('获取 communityId 失败:', e)
        return
      }

      if (!communityId) {
        return
      }

      // 调用接口获取灯杆监测数据
      request({
        url: '/app/bigScreen/getLightingPole',
        method: 'get',
        params: {
          communityId: communityId,
          deviceCode: '363832544e500bff2a66ffff'
        },
        showLoading: false
      }).then(response => {
        const res = response.data
        if (res && res.code === 0 && res.data) {
          const data = res.data
          const currentCommunityName = this.communityStore.currentCommunity
          const cfg = COMMUNITIES[currentCommunityName]

          if (!cfg || !cfg.data || !cfg.data.lightingPole || !cfg.data.lightingPole.metrics) {
            console.warn('未找到灯杆监测配置:', currentCommunityName)
            return
          }

          // 从后端返回的数据中根据 field 匹配并更新 value
          if (data.lightingPole && data.lightingPole.metrics) {
            const backendMetrics = data.lightingPole.metrics
            cfg.data.lightingPole.metrics.forEach(configMetric => {
              if (configMetric.field) {
                const backendMetric = backendMetrics.find(bm => bm.field === configMetric.field)
                if (backendMetric && backendMetric.value !== undefined && backendMetric.value !== null && backendMetric.value !== '') {
                  // 灯体开关字段，如果值为空则使用 "-"
                  if (configMetric.field === 'lightSwitch') {
                    configMetric.value = String(backendMetric.value)
                  } else {
                    configMetric.value = String(backendMetric.value || '0')
                  }
                } else if (configMetric.field === 'lightSwitch') {
                  // 灯体开关没有数据时，使用 "-"
                  configMetric.value = '-'
                }
              }
            })
          } else {
            // 如果接口没有返回数据，灯体开关设置为 "-"
            cfg.data.lightingPole.metrics.forEach(configMetric => {
              if (configMetric.field === 'lightSwitch') {
                configMetric.value = '-'
              }
            })
          }

          // 更新趋势数据（只有调光亮度有趋势数据）
          if (data.lightingPole && data.lightingPole.trend) {
            const backendTrend = data.lightingPole.trend
            if (backendTrend.series && cfg.data.lightingPole.trend && cfg.data.lightingPole.trend.series) {
              backendTrend.series.forEach(backendSeries => {
                const configSeries = cfg.data.lightingPole.trend.series.find(cs => cs.field === backendSeries.field)
                if (configSeries) {
                  configSeries.data = backendSeries.data || []
                } else {
                  // 如果配置中没有对应的 series，创建一个新的（从 metrics 中获取 name 和 unit）
                  const metric = cfg.data.lightingPole.metrics.find(m => m.field === backendSeries.field)
                  if (metric) {
                    cfg.data.lightingPole.trend.series.push({
                      name: metric.label,
                      unit: metric.unit,
                      field: backendSeries.field,
                      data: backendSeries.data || [],
                      min: metric.min || 0,
                      max: metric.max || 100
                    })
                  }
                }
              })
              // 确保配置中的所有 series 都有数据（如果后端没有返回，保持默认的空数组或0）
              cfg.data.lightingPole.trend.series.forEach(configSeries => {
                const backendSeries = backendTrend.series.find(bs => bs.field === configSeries.field)
                if (!backendSeries && configSeries.data.length === 0) {
                  // 如果后端没有返回该field的数据，且配置中也没有数据，初始化为24个0
                  configSeries.data = new Array(24).fill(0)
                }
              })
            } else {
              // 如果配置中没有 series，从配置的 metrics 构建 series
              if (backendTrend.series && cfg.data.lightingPole.metrics) {
                const newSeries = backendTrend.series.map(backendSeries => {
                  const metric = cfg.data.lightingPole.metrics.find(m => m.field === backendSeries.field)
                  return {
                    name: metric ? metric.label : backendSeries.field,
                    unit: metric ? metric.unit : '',
                    field: backendSeries.field,
                    data: backendSeries.data || [],
                    min: metric ? (metric.min || 0) : 0,
                    max: metric ? (metric.max || 100) : 100
                  }
                })
                // 确保调光亮度有对应的series（即使后端没有返回）
                const allFields = ['dimmingBrightness']
                allFields.forEach(field => {
                  if (!newSeries.find(s => s.field === field)) {
                    const metric = cfg.data.lightingPole.metrics.find(m => m.field === field)
                    if (metric) {
                      newSeries.push({
                        name: metric.label,
                        unit: metric.unit,
                        field: field,
                        data: new Array(24).fill(0),
                        min: metric.min || 0,
                        max: metric.max || 100
                      })
                    }
                  }
                })
                cfg.data.lightingPole.trend = {
                  hours: backendTrend.hours || cfg.data.lightingPole.trend.hours,
                  series: newSeries
                }
              } else {
                cfg.data.lightingPole.trend = {
                  hours: backendTrend.hours || cfg.data.lightingPole.trend.hours,
                  series: backendTrend.series || []
                }
              }
            }
          }

          // 重新从配置中读取更新后的数据（直接使用接口返回的数据，不强制更新最后一个值）
          this.lightingPoleMetrics = cfg.data.lightingPole.metrics
          this.lightingPoleTrendData = cfg.data.lightingPole.trend
        }
      }).catch(error => {
        console.warn('获取灯杆监测数据失败，使用默认配置数据:', error)
      })
    },
    // 格式化灯杆监测指标显示值
    formatLightingPoleValue(label, value) {
      // 灯体开关：0显示"开启"，1显示"关闭"，没有数据或值为"-"时显示"-"
      if (label.includes('灯体开关') || label.includes('开关')) {
        // 如果没有数据或值为 "-"，直接返回 "-"
        if (!value || value === '-' || value === 'null' || value === 'undefined' || value === '') {
          return '-'
        }
        const numValue = parseInt(value)
        // 如果解析失败，也返回 "-"
        if (isNaN(numValue)) {
          return '-'
        }
        return numValue === 0 ? '开启' : '关闭'
      }
      // 调光亮度：显示数值，保留整数
      const numValue = parseFloat(value)
      if (isNaN(numValue)) {
        return value
      }
      return Math.round(numValue).toString()
    },
    // 获取灯杆监测指标颜色类型
    getLightingPoleColorType(label, value) {
      // 灯体开关：0(开启)绿色，1(关闭)红色，没有数据("-")时显示蓝色（默认状态）
      if (label.includes('灯体开关') || label.includes('开关')) {
        // 如果没有数据或值为 "-"，返回蓝色（默认状态）
        if (!value || value === '-' || value === 'null' || value === 'undefined' || value === '') {
          return 'blue'
        }
        const numValue = parseInt(value)
        // 如果解析失败，也返回蓝色
        if (isNaN(numValue)) {
          return 'blue'
        }
        return numValue === 0 ? 'green' : 'red'
      }
      // 调光亮度：0-30红色(低)，30-60黄色(中)，60-80蓝色(较高)，80-100绿色(高)
      if (label.includes('调光亮度') || label.includes('亮度')) {
        const numValue = parseFloat(value) || 0
        if (numValue < 30) {
          return 'red'
        } else if (numValue < 60) {
          return 'yellow'
        } else if (numValue < 80) {
          return 'blue'
        } else {
          return 'green'
        }
      }
      return 'blue'
    },
    // 获取灯杆监测指标颜色
    getLightingPoleColor(label, value) {
      const colorType = this.getLightingPoleColorType(label, value)
      const colorMap = {
        'green': '#4caf50',
        'blue': '#00d4ff',
        'yellow': '#ffc107',
        'red': '#ff5a5a'
      }
      return colorMap[colorType] || '#00d4ff'
    }
  },
  beforeDestroy() {
    // 清理所有定时器
    if (this.entryStatsTimer) {
      clearInterval(this.entryStatsTimer)
      this.entryStatsTimer = null
    }
    if (this.environmentTimer) {
      clearInterval(this.environmentTimer)
      this.environmentTimer = null
    }
    if (this.waterQualityTimer) {
      clearInterval(this.waterQualityTimer)
      this.waterQualityTimer = null
    }
    if (this.lightingPoleTimer) {
      clearInterval(this.lightingPoleTimer)
      this.lightingPoleTimer = null
    }
    // 兼容旧的 updateTimer（如果存在）
    if (this.updateTimer) {
      clearInterval(this.updateTimer)
      this.updateTimer = null
    }
    // 销毁图表
    if (this.alarmChart) {
      this.alarmChart.dispose()
    }
    // 移除窗口resize事件监听
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
  }
}
</script>

<style lang="scss" scoped>
.right-panel-wrapper {
  position: absolute;
  top: 20px;
  right: 20px;
  width: min(430px, 22vw); // 自适应：最大430px，或屏幕宽度的22%
  min-width: 320px; // 最小宽度
  max-width: 430px; // 最大宽度
  height: calc(100% - 40px);
  z-index: 10; // 右侧面板在地图上方
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: rgba(15, 30, 50, 0.85);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  
  // 响应式调整
  @media (max-width: 1920px) {
    width: min(410px, 22vw);
    max-width: 410px;
  }
  
  @media (max-width: 1600px) {
    width: min(380px, 24vw);
    max-width: 380px;
    min-width: 300px;
  }
  
  @media (max-width: 1366px) {
    width: min(350px, 26vw);
    max-width: 350px;
    min-width: 280px;
  }
}

.right-panel {
  display: flex;
  flex-direction: column;
  gap: 8px; // 与左侧保持一致
  flex: 1; // 占据剩余空间
  min-height: 0; // 重要：允许 flex 子元素缩小
  overflow-y: auto; // 内容超出时显示滚动条
  overflow-x: hidden;
  max-height: 100%; // 限制最大高度，确保可以滚动

  // 隐藏滚动条但保留滚动功能
  scrollbar-width: none; // Firefox
  -ms-overflow-style: none; // IE/Edge

  &::-webkit-scrollbar {
    display: none; // Chrome/Safari
  }

  // 所有卡片默认根据内容自适应
  .card {
    flex: 0 0 auto;
    min-height: 0; // 允许收缩
  }

  // 最后一个卡片占据剩余空间，并设置为 flex 容器
  .card:last-child {
    flex: 1 0 auto; // 占据剩余空间，但不收缩，允许根据内容增长
    display: flex;
    flex-direction: column;
    min-height: 0; // 允许收缩
    max-height: 60vh; // 限制最大高度，避免在小屏幕上占用过多空间
    overflow: hidden; // 防止内容溢出
  }

  // 当 section-environment 不是最后一个时，也需要确保图表能显示
  .section-environment:not(:last-child) {
    display: flex !important; // 强制使用 flex 布局
    flex-direction: column;

    .section-header {
      flex-shrink: 0;
    }
    }
    }
.right-panel ::v-deep .card {
  padding: 10px; // 与左侧保持一致
  }
.right-panel ::v-deep .section-title {
  margin-bottom: 0; // 与左侧保持一致
  font-size: 14px; // 与左侧保持一致，稍微缩小
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; // 与左侧保持一致
}
.entry-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.entry-stat-item {
  padding: 10px;
  background: rgba(0, 212, 255, 0.05);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  .stat-label {
    color: #a0b3c8;
    font-size: 12px;
  }
  .stat-value {
    color: #00d4ff;
    font-weight: bold;
    font-size: 12px;
  }
}
.alarm-count {
  text-align: center;
  margin-bottom: 10px;
  .count-label {
    display: block;
    color: #a0b3c8;
    font-size: 12px;
  }
  .count-value {
    color: #00d4ff;
    font-size: 32px;
    font-weight: bold;
  }
  .count-unit {
    color: #a0b3c8;
  }
}
.alarm-chart {
  height: 180px;
  .chart-container {
    width: 100%;
    height: 100%;
  }
}
  .section-alarm {
  // flex 布局由 .card:last-child 控制
  .section-header {
    flex-shrink: 0;
    margin-bottom: 10px;
  }

  .section-title {
    flex-shrink: 0;
    margin-bottom: 0;
  }

  .alarm-count {
    flex-shrink: 0;
  }

  .alarm-chart {
    flex-shrink: 0;
  }
}
.alarm-list {
  flex: 1; // 占据剩余空间
    overflow-y: auto; // 内容超出时显示滚动条
    padding-right: 2px;

    // 隐藏滚动条但保留滚动功能
    scrollbar-width: none; // Firefox
    -ms-overflow-style: none; // IE/Edge

    &::-webkit-scrollbar {
      display: none; // Chrome/Safari
    }
}
.alarm-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  margin-bottom: 8px;
  border-left: 3px solid; // 颜色通过内联样式动态设置
  border-radius: 4px;
  .alarm-type {
    color: #a0b3c8;
    font-size: 12px;
  }
  .alarm-count-text {
    font-weight: 700;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    // 边框和背景通过内联样式动态设置
  }
}

.section-environment {
  // flex 布局由 .card:last-child 控制（当它是最后一个时）

  .section-header {
    flex-shrink: 0;
    margin-bottom: 10px;
  }

  .section-title {
    flex-shrink: 0;
    margin-bottom: 0;
  }

}
</style>

